import { navigateAction } from 'fluxible-router';
import ShoppingCartConstants from '../constants/ShoppingCartConstants';
import CustomerActions from './CustomerActions';
import ShoppingCart from '../models/ShoppingCart';
import Order from '../models/Order';

const isBrowser = (typeof window !== 'undefined');

const ShoppingCartActions = {
  fetch(context, payload) {
    context.dispatch(ShoppingCartConstants.FETCH_SHOPPING_CART_START, {});

    if(!payload.store_id && !payload.store_slug) {
      let currentStore = context.getCurrentStore();
      if(!currentStore) {return null;}
      payload.store_id = currentStore.id;
    }

    return context
      .delectoryApi
      .shoppingCarts
      .cart(payload)
      .then(responsePayload => {
        let shoppingCart = new ShoppingCart(responsePayload.shopping_cart);
        context.dispatch(ShoppingCartConstants.FETCH_SHOPPING_CART_SUCCESS, shoppingCart);
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.FETCH_SHOPPING_CART_FAILURE, err);
      });
  },

  setCouponCode(context, payload) {
    let storeId = payload.store_id;

    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .setCouponCode(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        return shoppingCart;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
      });
  },

  setShippingAddress(context, payload) {
    let storeId = payload.store_id;
    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .setShippingAddress(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        return shoppingCart;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
      });
  },

  setPaymentMethod(context, payload) {
    let storeId = payload.store_id;
    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .setPaymentMethod(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        return shoppingCart;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
      });
  },

  setShippingMethod(context, payload) {
    let storeId = payload.store_id;
    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .setShippingMethod(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        return shoppingCart;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
      });
  },

  addItem(context, payload) {
    let storeId = payload.store_id;
    let inventoryRecord = payload.inventory_record;
    delete payload.inventoryRecord;
    let navigateToBagOnSuccess = payload.hasOwnProperty('navigateToBagOnSuccess') ? payload.navigateToBagOnSuccess : false;
    delete payload.navigateToBagOnSuccess;

    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .addItem(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        context.trackEvent('Product Added', {
          cart_id: shoppingCart.id,
          product_id: inventoryRecord.id,
          name: inventoryRecord.name,
          brand: inventoryRecord.brand,
          price: inventoryRecord.current_price
        });
        if(navigateToBagOnSuccess) {
          return context.executeAction(navigateAction, {routeName: 'bag'});
        }
        return null;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
        return null;
      });
  },

  updateItem(context, payload) {
    let storeId = payload.store_id;
    let inventoryRecord = payload.inventoryRecord;
    delete payload.inventoryRecord;
    let navigateToBagOnSuccess = payload.hasOwnProperty('navigateToBagOnSuccess') ? payload.navigateToBagOnSuccess : false;
    delete payload.navigateToBagOnSuccess;

    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .updateItem(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        if(payload.quantity === 0) {
          context.trackEvent('Product Removed', {
            cart_id: shoppingCart.id,
            product_id: inventoryRecord.id,
            name: inventoryRecord.name,
            brand: inventoryRecord.brand,
            price: inventoryRecord.current_price
          });
        }
        if(navigateToBagOnSuccess) {
          return context.executeAction(navigateAction, {routeName: 'bag'});
        }
        return null;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
        return null;
      });
  },

  removeItem(context, payload) {
    let storeId = payload.store_id;
    let inventoryRecord = payload.inventoryRecord;
    delete payload.inventoryRecord;
    let navigateToBagOnSuccess = payload.hasOwnProperty('navigateToBagOnSuccess') ? payload.navigateToBagOnSuccess : false;
    delete payload.navigateToBagOnSuccess;

    context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_START, storeId);

    return context
      .delectoryApi
      .shoppingCarts
      .removeItem(payload)
      .then(payload => {
        let shoppingCart = new ShoppingCart(payload.shopping_cart);
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS, shoppingCart);
        context.trackEvent('Product Removed', {
          cart_id: shoppingCart.id,
          product_id: inventoryRecord.id,
          name: inventoryRecord.name,
          brand: inventoryRecord.brand,
          price: inventoryRecord.current_price
        });
        if(navigateToBagOnSuccess) {
          return context.executeAction(navigateAction, {routeName: 'bag'});
        }
        return null;
      })
      .catch(err => {
        context.dispatch(ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
        return null;
      });
  },

  checkout(context, payload) {
    let storeId = payload.store_id;
    context.dispatch(ShoppingCartConstants.CHECKOUT_SHOPPING_CART_START, storeId);
    let checkout = (paymentMethodId) => {
      if(paymentMethodId) {
        payload.payment_method_id = paymentMethodId;
        delete payload.payment_method;
      }
      return context
        .delectoryApi
        .shoppingCarts
        .checkout(payload)
        .then(responsePayload => {
          let shoppingCart = new ShoppingCart(responsePayload.shopping_cart);
          let order = new Order(responsePayload.order);
          context.dispatch(ShoppingCartConstants.CHECKOUT_SHOPPING_CART_SUCCESS, {shoppingCart, order});
          return context.executeAction(navigateAction, {routeName: 'orderConfirmation'});
        })
        .catch(err => {
          context.dispatch(ShoppingCartConstants.CHECKOUT_SHOPPING_CART_FAILURE, {storeId: storeId, error: err});
          return null;
        });
    };
    if(payload.payment_method) {
      return CustomerActions.addPaymentMethod(context, {
        payment_method: payload.payment_method,
        onSuccessSetPaymentOnCart: false
      }).then((customer) => {
        return checkout(customer.payment_methods.get(0).id);
      }).catch((error) => {
        context.dispatch(ShoppingCartConstants.CHECKOUT_SHOPPING_CART_FAILURE, {storeId: storeId, error: null});
      });
    }
    return checkout();
  }
};

export default ShoppingCartActions;



// WEBPACK FOOTER //
// banquet/actions/ShoppingCartActions.js